export default "__VITE_ASSET__CalC97Po__"